import { render, staticRenderFns } from "./LibraryOfParliament.vue?vue&type=template&id=e6586f62&"
import script from "./LibraryOfParliament.vue?vue&type=script&lang=js&"
export * from "./LibraryOfParliament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports